import React from 'react'
import { Monitor } from 'lucide-react'

const DigitalExperienceDashboard: React.FC = () => {
  return (
    <div className="card py-16 text-center">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-purple-50 dark:bg-purple-900/30">
        <Monitor className="h-8 w-8 text-purple-400 dark:text-purple-300" />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Digital Experience</h2>
      <p className="mt-2 text-gray-500 dark:text-gray-400">Dashboard coming soon.</p>
      <p className="mt-1 text-sm text-gray-400 dark:text-gray-500">This workspace is under active development.</p>
    </div>
  )
}

export default DigitalExperienceDashboard
